<template>
  <div>
    <div class="form-wrapper">
      <table>
        <tr>
          <td>お名前</td>
          <td>
            <div>{{ user.nameKanzi }}</div>
          </td>
        </tr>
        <tr>
          <td>フリガナ</td>
          <td><div>{{ user.nameKata }}</div></td>
        </tr>
        <tr>
          <td>メールアドレス</td>
          <td><div>{{ user.adress }}</div></td>
        </tr>
        <tr>
          <td>電話番号</td>
          <td><div>{{ user.tel }}</div></td>
        </tr>
        <tr>
          <td>メッセージ本文</td>
          <td><div>{{ user.contents }}</div></td>
        </tr>
      </table>
    </div>
    <div class="confirm-button-wrapper">
      <div class="confirm-button">
        <button @click="$router.back()">修正する</button>
      </div>
      <div class="confirm-button">
        <button @click="confirmSubmit">この内容で送信</button>
      </div>
    </div>
  </div>
</template>


<script>
export default {
    props: {
    user: Object
  },
  methods: {
    confirmSubmit() {
      alert('送信されました！');
      this.$router.push("/");
    }
  }
}
</script>


<style lang="scss" scoped>
.form-wrapper {
  display: flex;
  justify-content: center;
  margin: 50px auto;
}
.confirm-button-wrapper {
  display: flex;
  flex-direction: column;
}

.confirm-button {
  margin: 15px;
}

table {
  tr {
    &:last-child div {
      word-wrap: break-word;
      word-break: normal;
    }
  }

  td {
    padding-bottom: 20px;

    &:nth-child(1) {
      text-align: right;
      padding-right: 20px;
      vertical-align: top;
    }

    &:nth-child(2) div {
      text-align: left;
      color: $colorRed; 
      width: 150px;
      height: auto;
      background-color: #fff;
      border: .5px solid #000;
      font-size: 13px;
      padding: 1px;
    }
  }
}



</style>